import theme from './theme';
const focus = props => theme(props).focus;
export const focusOutlineColor = props => focus(props).outlineColor;
export const focusOutlineStyle = props => focus(props).outlineStyle;
export const focusOutlineWidth = props => focus(props).outlineWidth;
export const focusOutlineOffset = props => focus(props).outlineOffset;